import { Address } from 'viem';

export const wBtcTokenAddress: Address = '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599';
